import ReactTable from "../../components/react-table/order-create/index";

function NewOrdenCompra() {
  return (
    <div>
      <ReactTable />
    </div>
  );
}

export default NewOrdenCompra;
